var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgProductChosenIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 144,
    viewBox: "0 0 130 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M128.6 12.3999C128.6 12.3999 128.6 38.3999 128.6 66.2999C125.5 107 136.6 132.2 120.7 140C101.7 146.4 95.4001 142.3 57.6001 143.4C22.1001 144.4 1.80016 142.5 0.400164 131.8C0.400164 128.9 0.400164 63.2999 0.400164 30.5999C1.60016 13.8999 -9.79987 -0.400093 41.8001 0.999907C90.8001 1.7999 123.2 -3.7001 128.6 12.3999Z",
    fill: "#B4A7AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgProductChosenIcon);
export default __webpack_public_path__ + "static/media/bg_product_chosen_icon.6a9d6f099406f90be28abfdeed4b5122.svg";
export { ForwardRef as ReactComponent };